module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Typewriter-Medium.3c96b3a4.woff2";